// eslint-disable-next-line no-process-env
const VERSION = process.env.npm_package_version;
// eslint-disable-next-line no-process-env
const NAME = process.env.npm_package_name;

export default (error) => {
  if (window.Sentry) {
    window.Sentry.withScope((scope) => {
      scope.setTag('dependency.name', NAME);
      scope.setTag('dependency.version', VERSION);
      scope.setContext('dependency', {
        name: NAME,
        version: VERSION,
      });
      window.Sentry.captureException(error);
    });
  }
};
